<template>
    <Modal
        class="agreement_content nobor"
        v-model="modalShow"
        :width="900"
        :closable="false"
        :mask="false"
        :scrollable="false"
        cancel-text="关闭"
        ok-text="同意并关闭"
        @on-ok="agreementOk"
        @on-cancel="agreementNo"
    >
        <div class="agreement_box" v-html="agreementnews"></div>
    </Modal>
</template>

<script>
    export default {
        props: ['agreementShow', 'agreementnews'],
        data() {
            return {
                modalShow: false, // 弹窗是否打开
            }
        },
        methods: {
            agreementOk () { // 点击确认按钮
                this.modalShow = false
                this.$emit('agreementClear', 'ok')
            },
            agreementNo () { // 点击关闭按钮
                this.modalShow = false
                this.$emit('agreementClear')
            }
        },
        watch: {
            agreementShow () {
                this.modalShow = this.agreementShow
            }
        }
    }
</script>

<style scoped>

.agreement_box {
    height: 690px;
    margin: -16px;
    padding: 0 16px;
    overflow: auto;
}

</style>


// WEBPACK FOOTER //
// src/components/component/popup/agreement.vue